import GolfCourseService from "@/services/GolfCourseService";
import { SET_CURRENT_INTERVIEW } from "../mutation-types";

const localState = () => ({
  currentInterview: {},
  interviewTypes: [
    {
      id: 2,
      name: `Video`,
    },
    {
      id: 1,
      name: `Text`,
    },
  ],
});

const mutations = {
  [SET_CURRENT_INTERVIEW](state, value) {
    state.currentInterview = value;
  },
};

const actions = {
  async updateInterview({ commit }, data) {
    return await GolfCourseService.updateInterview(data);
  },
  async newComment({}, data) {
    return await GolfCourseService.newComment(data);
  },
  async getInterviewData({state, commit}, id) {
    const data = await GolfCourseService.getInterview(id);
    if(data) {
      commit(SET_CURRENT_INTERVIEW, data)
    } else commit(SET_CURRENT_INTERVIEW, {})
  },
};

export default {
  namespaced: true,
  state: localState(),
  mutations,
  actions,
};
